import {$, $$, alignSidePanelToHeaderTopPosition, clickOnEnterKey, get, getDataJson, gtmEvent, Key, documentHasVisibleFocus, getDataText} from "@/Utils"
import {updateHeaderCartHtml} from "@/CartModule"
import {EuronicsResponse} from "@/interfaces"
import {highlightProductCard} from "@/ProductModule"
import {EuronicsResponseHandler} from "@/EuronicsResponseHandler";
import {GtmEventType} from "@/enums"
import {initLogin} from "@/sharedComponents/Header/Login"
import {closeOtherTooltips} from "@/sharedComponents/Tooltip.js";

export async function fetchAndInsertPartial(loadUrl: string, loadTarget: string, overrideTarget=""): Promise<boolean> {
    return new Promise((resolve) => {
        const cssSelectorForTarget = overrideTarget ? overrideTarget : `#${loadTarget}-container`;
        getDataText(loadUrl, (html) => {
            $(cssSelectorForTarget).innerHTML = html;
            resolve(true);
        });
    });
}


export function bindCartPanelDeletes() {
    $$(".cart-list__delete").forEach(el => {
        el.addEventListener("click", e => {
            const target = e.target as Element;
            const orderProductId = target.getAttribute("data-id");
            const url = window.config.removeFromCartUrl + "?id=" + orderProductId;

            const handleCartResponse = (resp: RemoveFromCartResponse) => {
                updateHeaderCartHtml();
                if (resp.cartMetaData) {
                    $$("[data-products-translation]").forEach(x => x.innerHTML = resp.cartMetaData.productsTranslation);
                    $$("[data-cart-products-total]").forEach(x => x.innerHTML = resp.cartMetaData.cartProductsTotal);
                }
                if (resp.productId && !window.isResponsive) {
                    const activeAddToCartButtons = $$(`.add-to-cart--active[data-add-to-cart-id='${resp.productId}']`)
                    if (activeAddToCartButtons.length > 0) {
                        // Last btn is for desktop. 
                        // In mobile devices we don't show cart panel. Thus, products can't be removed from panel.
                        const activeAddToCartButton = activeAddToCartButtons[activeAddToCartButtons.length - 1];
                        activeAddToCartButton.classList.remove("add-to-cart--active")
                        activeAddToCartButton.querySelectorAll("use")[0]?.setAttribute("href", "#cart-icon-idle")
                        activeAddToCartButton.querySelectorAll("use")[1]?.setAttribute("href", "#cart-icon-hover")
                    }
                }

                const productCardSrc = $(".add-to-cart[data-add-to-cart-id='" + resp.productId + "']");
                if (productCardSrc) {
                    highlightProductCard(resp.productId.toString(), false, "is-in-cart");
                    productCardSrc.classList.remove("add-to-cart--active");
                }

                initLogin();

                gtmEvent(GtmEventType.AddToCart, null, null, null, null, resp.gtmAddToCartOptions)
            };

            const callback = (resp: EuronicsResponse) => EuronicsResponseHandler(resp, handleCartResponse, get("cart-panel-wrapper"));

            getDataJson(url, callback).then();
        });
    });
}

export function bindPanelClose(el: HTMLElement) {
    el.addDataBoundEventListener("click",
        (e: Event) => {
            const target = e.target as HTMLElement;
            // Disable closing panel on certain elements
            if (target.closest("[data-no-panel-close]") !== null) {
                return
            }
            e.stopPropagation();
            closePanel();
        }, "close-panel");
    el.addDataBoundEventListener("keydown", (e: KeyboardEvent) => {
        clickOnEnterKey(e, el)
    }, "enter-keypress-bound")
}

export function closePanel() {
    $(".lr-panel--active .panel-right")?.classList.remove("panel-right--active");
    $("#customer-service-button")?.classList.remove("highlighted");
    setTimeout(() => {
        $(".panel__wrapper--active")?.classList.remove("panel__wrapper--active");
        $(".panel__overlay--active")?.classList.remove("panel__overlay--active");
        const activePanel = $("[scroll-to-tab]");
        if (!activePanel) {
            document.body.classList.remove("panel-open");
            $$(".responsive-lr-panel").forEach(x => x.classList.remove("lr-panel--active"));
            $$(".responsive-lr-panel").forEach(x => x.classList.remove("lr-panel--visible"));
        }
        $$(".lr-panel").forEach(x => x.classList.remove("lr-panel--active"));
        $$(".lr-panel").forEach(x => x.classList.remove("lr-panel--visible"));
        window.updateZendeskOffset();
    }, 300)
}

export async function initPanels() {
    $$("[data-panel-target]").forEach(el => {
        el.addDataBoundEventListener("click",
            async (ev: Event) => {
                ev.preventDefault() // For example when inside checkbox label

                const panelTarget = el.getAttribute("data-panel-target");
                if (el.getAttribute("data-load-url") && panelTarget){
                    await fetchAndInsertPartial(el.dataset.loadUrl + "?returnUrl=" + window.location.pathname, panelTarget)
                    if (panelTarget === "login-panel") {
                        initLogin()
                    }
                }
                openPanel(panelTarget);
            });
        el.addDataBoundEventListener("keydown", (ev: KeyboardEvent) => {
            clickOnEnterKey(ev, el)
        }, "enter-keypress-bound");
    });
    $$("[data-responsive-panel-target]").forEach(el => {
        el.addDataBoundEventListener("click",
            () => {
                if (!window.isResponsive)
                    return;
                openPanel(el.getAttribute("data-responsive-panel-target"));
            });
        if (!el.hasAttribute("data-keydown-bound")) {
            el.addDataBoundEventListener("keydown", (event: KeyboardEvent) => {
                if(document.activeElement === el){
                    clickOnEnterKey(event, el);
                }
            }, "enter-keypress-bound");
            el.setAttribute("data-keydown-bound", "true");
        }
    });

    $$("[data-panel-close]").forEach(el => bindPanelClose(el));

    document.addEventListener("keyup", (e: KeyboardEvent) => {
        if (e.key === Key.Escape) {
            if (closeOtherTooltips(null)) {
                return
            }
            closePanel()
        }
    });

    window.addEventListener("resize", () => {
        alignSidePanelToHeaderTopPosition();
    });

    window.responsiveObserverFunctions = (window.responsiveObserverFunctions || [])
    window.responsiveObserverFunctions.push(closeResponsivePanelOnNonResponsive)
}

const closeResponsivePanelOnNonResponsive = () => {
    if (window.isResponsive == false && $("body.panel-open .responsive-lr-panel.lr-panel--active")) closePanel();
}

export function openPanel(panelId: string) {
    if (panelId) {
        const panel = get(panelId)
        if (!panel) {
            return
        }

        document.body.classList.add("panel-open")
        if (panel.classList.contains("lr-panel") || panel.classList.contains("responsive-lr-panel")) {
            //visible ja active on eraldatud, kuna paneeli peab esmalt nähtavaks tooma, et animatsioonid töötaks korrektselt
            panel.classList.add("lr-panel--visible")
            setTimeout(() => {
                panel.classList.add("lr-panel--active")
                panel.querySelector(".panel-right").classList.add("panel-right--active")
                if (panel.classList.contains("tab-content")) {
                    panel.classList.add("tab-content--active")
                }
                alignSidePanelToHeaderTopPosition();

                if (!window.isResponsive && documentHasVisibleFocus()) {
                    let titleElem = panel.querySelector(".panel__title") as HTMLElement;
                    if(titleElem){
                        titleElem.focus();
                    } else {
                        let firstElem = panel.querySelector("button,h3,h2") as HTMLElement;
                        firstElem?.focus();
                    }
                }
                window.updateZendeskOffset()
            }, 1)
        }
    }
}